import { FC, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { setAuth } from '../../app/modules/auth/core/AuthHelpers';
import '../styles/LoadingOverlay.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const getUserProfile = async (token: string) => {
    try {
        const response = await axios.get(`${API_URL}/v1/auth0/user-profile`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error: unknown) {
        if (error instanceof Error) {
            console.error('Error fetching user profile:', error.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Error fetching user profile: ${error.message}`,
                confirmButtonText: 'Confirm',
            });
        } else {
            console.error('Unexpected error fetching user profile', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Unexpected error fetching user profile',
                confirmButtonText: 'Confirm',
            });
        }
        throw error;
    }
};

const RedirectingPage: FC = () => {
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();
    const [showLoading, setShowLoading] = useState(true);

    useEffect(() => {
        // Capture redirect parameters from URL
        const params = new URLSearchParams(window.location.search);
        const errorDescription = params.get('error_description');

        // If there is an error in the parameters, show an alert and redirect
        if (errorDescription) {
            setShowLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Authentication Error',
                text: errorDescription,
                confirmButtonText: 'Confirm',
            }).then(() => {
                navigate('/auth');
            });
            return;
        }

        const fetchUserProfile = async () => {
            try {
                const token = await getAccessTokenSilently();
                console.log('Access token:', token);
                setAuth({ api_token: token });
                const profile = await getUserProfile(token);

                if (profile) {
                    navigate('/dashboard');
                }
            } catch (error) {
                console.error('Error fetching user profile:', error);
                navigate('/auth');
            }
        };

        if (isAuthenticated) {
            fetchUserProfile();
        } else {
            navigate('/auth');
        }
    }, [isAuthenticated, getAccessTokenSilently, navigate]);

    return (
        <>
            {!showLoading ? null : (
                <div className="loading-overlay">
                    <div className="loading-message">
                        You will be redirected soon...
                    </div>
                </div>
            )}
        </>
    );
};

export default RedirectingPage;
